



















































import {Component, Vue} from "vue-property-decorator";
import DeleteButton from "@/components/datatable/DeleteButton.vue";
import EForm from "@/components/datatable/EForm.vue";
import Number from "@/components/inputs/Number.vue";
import TextField from "@/components/inputs/TextField.vue";
import Id from "@/components/inputs/Id.vue";

class productVariant {
    product_sku_id !:number;
    name !:string;
}
@Component({
    components: {
        DeleteButton,EForm,Number,TextField,Id
    }
})
export default class ProductVariant extends  Vue{
    items : productVariant[] | null = null;
    dialog = false;
    title:string = "";
    search: string = "";
    baseAction:string = "productVariant";
    action:string = this.baseAction;
    data : productVariant = new productVariant();
    headers = [
        {
            text: "Id",
            align: "start",
            sortable: true,
            value: "product_sku_id"
        },
        {text: "Başlık", value: "name"},
        {text: "İşlemler", value: "actions"}
    ];
    edit(item:productVariant){
        this.title = "Düzenle";
        this.data = item;
        this.action = this.baseAction + "/" + item.product_sku_id;
        this.dialog = true;
    }
    goOptions(item:productVariant){
        this.$store.dispatch("go","/urunayarlari/urunvaryasyon/"+item.product_sku_id);
    }
    add(){
        this.title = "Ekle";
        this.action = this.baseAction;
        this.data = new productVariant();
        this.dialog = true;
    }
    async get(){
        this.dialog = false;
        let response = await this.$http.get(this.baseAction);
        this.items = response.data;
    }
    created(){
        this.get();
    }
};
